import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class LogSystemUdalosti extends BaseApi {
	getTableData(filter: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/LogSystemUdalosti`, filter);
	}

	getDetail(logId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetDetail?logId=${logId}`);
	}
}
export const apiProvider = new LogSystemUdalosti(DMS_MODULE, NAME);
